import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	JednotekCil: null as number | null,
	JednotekZdr: null as number | null,
	MenaIdCil: null as number | null,
	MenaIdZdr: null as number | null,
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	EditPracIdText: null as string | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as string | null,
	FixacePrp: null as boolean | null,
	ZaznamId: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: { MenaId: [] },
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
